module.exports = __webpack_public_path__ + "img/logo.c6760461.png";